// ============================================================
// client/src/store/useAuthStore.js — 认证状态管理
// ============================================================

import { create } from "zustand";

const TOKEN_KEY = "bp_token";
const USER_KEY = "bp_user";
const PENDING_TASK_KEY = "bp_pending_task";
const API_BASE = process.env.REACT_APP_API_URL || "";

function clearStoredAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(PENDING_TASK_KEY);
}

const useAuthStore = create((set, get) => ({
  // 状态
  token: localStorage.getItem(TOKEN_KEY) || null,
  user: JSON.parse(localStorage.getItem(USER_KEY) || "null"),
  quota: null,
  initialized: false, // 标记是否已完成启动时的 token 验证

  // UI 状态
  requireContactBinding: false,

  // 是否已登录
  get isLoggedIn() {
    return !!get().token;
  },

  // 启动时验证 token 并恢复完整会话
  initAuth: async () => {
    const token = get().token;
    if (!token) {
      set({ initialized: true });
      return;
    }
    try {
      const resp = await fetch(`${API_BASE}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (resp.status === 401 || resp.status === 403) {
        clearStoredAuth();
        set({ token: null, user: null, quota: null, initialized: true });
        return;
      }
      if (!resp.ok) {
        set({ initialized: true });
        return;
      }
      const data = await resp.json();
      localStorage.setItem(USER_KEY, JSON.stringify(data.user));
      set({ user: data.user, quota: data.quota, initialized: true });
    } catch (err) {
      set({ initialized: true });
    }
  },

  // 登录成功
  setAuth: (token, user, quota) => {
    // 切换账号时清理旧账号的 pending task
    const oldUser = get().user;
    if (oldUser && oldUser.id !== user.id) {
      localStorage.removeItem(PENDING_TASK_KEY);
    }
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    set({ token, user, quota, initialized: true });
  },

  // 更新额度
  setQuota: (quota) => set({ quota }),

  // 更新用户信息
  setUser: (user) => {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    set({ user });
  },

  // 登出
  logout: () => {
    clearStoredAuth();
    set({ token: null, user: null, quota: null });
  },

  // 业务拦截状态
  setRequireContactBinding: (v) => set({ requireContactBinding: v }),
}));

export default useAuthStore;
